export default {"src":"/_next/static/media/AdvancedDiagnosticTechnology.58858bc2.svg","height":52,"width":51,"blurWidth":0,"blurHeight":0};